/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 17.11.24
 *
 */


import 'reflect-metadata'
import '../utils/CustomPrototype.js'
import Vue from "@/entry/setupVue3.js"

import './stylesFull.scss'

// let loadFullStyles = () => import ('./stylesFull.scss')
// loadFullStyles()

import './hierarchyImports'
import "./setupGlobalObjects.js"

import "./elementui-imports"
import "./dataManager-imports"
import "./errorHandler"
import "./setupPaddle"
import "./globalComponents"
import "./commonClientServerCode"
import "../utils/globalFunctions"
import "../main/SetupSessionObject"
import store from '../store'
import routerFn from '../router'
// import App from './App'
import {VueSignaturePad} from 'vue-signature-pad';
import Sticky from 'vue-sticky-directive'
import Server from "@/core/js/backend/Server";
import '../utils/polyfills'
import VueCookies from 'vue-cookies'
import CommonObject from "@shared/CommonObject.js";
// import "../scripts/UnitTests/AccessRulesIndex.mjs"
Vue.use(VueCookies);
Vue.use(Sticky)

CommonObject.dataManager.analyticManager = CommonObject.analyticManager
CommonObject.cookies = Vue.config.globalProperties.$cookies

let server = new Server(store)
server.dataManager = CommonObject.dataManager
Vue.config.globalProperties.$server = server
//TODO legacy code support - needs to be removed after refactoring
Vue.config.globalProperties.$authManager.server = server

Vue.config.globalProperties.$authManager.analyticManager = CommonObject.analyticManager
Vue.config.globalProperties.$analyticManager = CommonObject.analyticManager
Vue.config.globalProperties.$dataManager.store = store
Vue.config.globalProperties.store = store

Vue.config.globalProperties.cookie = new Cookie()

console.log("Vue = ", Vue)

let routerManager = routerFn(Vue.config.globalProperties.$authManager, store)


// Vue.use(VueSync)
Vue.component("VueSignaturePad", VueSignaturePad);


Vue.config.globalProperties.printHtml = window.print


import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)


import VueDraggableResizable
	from '@/core/components/external/vue-draggable-resizable/components/vue-draggable-resizable.vue'
import '@/core/components/external/vue-draggable-resizable/components/vue-draggable-resizable.css'

Vue.component('vue-draggable-resizable', VueDraggableResizable)


// import VueProgressBar from 'vue-progressbar'
// import VueProgressBar from "@aacassandra/vue3-progressbar";
import VueProgressBar from "@external/vue3-progressbar/src";

Vue.use(VueProgressBar)


// import VueMq from 'vue-mq'
// Vue.use(VueMq, {
// 	breakpoints: { // default breakpoints - customize this
// 		xs: 576,
// 		sm: 768,
// 		md: 992,
// 		lg: 1200,
// 		xl: Infinity,
// 	},
// 	defaultBreakpoint: 'sm' // customize this for SSR
// })


// https://stackoverflow.com/a/37521683/1713920
// window.app = vm

import * as ModalDialogs from 'vue3-modal-dialogs'
import Cookie from "@/core/js/Cookie/Cookie.js";

Vue.use(ModalDialogs)

// Vue.config.productionTip = false//process.env.NODE_ENV !== "prod"

Vue.use(store);

export {
	Vue,
	store,
	routerManager
}
